import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import Footer from '../../layout/Footer/Footer';
import Header from '../../layout/Header/Header';
import bg2 from './../../../images/background/bg18.jpg';
import Aos from "aos";

import bnr3 from './../../../images/main-slider/image3.jpg';
import pic6 from '../../../images/portfolio/project1/boucherie.webp';
import pic7 from '../../../images/portfolio/project1/datte_500.webp';
import pic8 from '../../../images/background/politique.jpeg';
import ScrollToTop from '../../Shared/ScrollToTop';
import { useTranslation } from "react-i18next";

const Présentation = ({ lang, SetLang }) => {
    const [t, i18n] = useTranslation('traduction');

    useEffect(() => {
        Aos.init({
            duration: 1500,
            disable: 'mobile',
            once: true,
            mirror: false
        });
        i18n.changeLanguage(lang);
    }, [i18n, lang]);
    return (
        <>
            <Header lang={lang} SetLang={SetLang} />

            <div class="page-content bg-white">
                <div class="dlab-bnr-inr overlay-black-middle text-center bg-pt" style={{ backgroundImage: "url(" + bnr3 + ")" }}>
                    <div class="container">
                        <div class="dlab-bnr-inr-entry align-m text-center">
                            <h1 class="text-white">{t('Présentation')}</h1>
                            <div class="breadcrumb-row">
                                <ul class="list-inline">
                                    <li><a href="/">{t('Accueil')}</a></li>
                                    <li>{t('À Propos De Nous')}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-block">
                <div class="section-full content-inner bg-white">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12 m-b30" data-aos="zoom-out-right">
                                <div class="our-story">
                                    <h3><span>{t('Notre Mission')}</span> </h3>
                                    <h6 class="title"><span class="text-primary">{t('Packaging Solutions..')}</span></h6>

                                    <p>{t('DEVPACK  est une entreprise industrielle offrant des emballages plastiques standards ou personnalisés basés sur le mousse de polystyrène XPS ,  afin d’accompagner le développement de ses clients principalement dans le secteur des industries alimentaire, agroalimentaire, conditionnement…')}</p>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12 m-b30 our-story-thum" data-aos="zoom-out-left">
                                <img src={pic6} class="radius-sm" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12 m-b30 our-story-thum" data-aos="zoom-out-right">
                                <img src={pic7} class="radius-sm" alt="" />
                            </div>
                            <div class="col-lg-6 col-md-12 m-b30" data-aos="zoom-out-left">
                                <div class="our-story">
                                    <h3><span>{t('Notre Vision')}</span> </h3>
                                    <h6 class="title"><span class="text-primary">{t('Packaging Solutions..')}</span></h6>
                                    <p>{t('DEVPACK est une entreprise de référence sur le marché national. Elle innove pour faire évoluer les emballages  basés sur le mousse de polystyrène XPS  de ses clients tout en respectant les standards nationaux et  internationaux. Elle mobilise une équipe hautement qualifiée et expérimentée opérant dans des installations modernes et utilisant des technologies de pointe.')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section-full box-about-list">
                        <div class="row spno">
                            <div class="col-lg-6 col-md-12">
                                <img src={pic8} alt="" class="img-cover" />
                            </div>
                            <div class="col-lg-6 col-md-12 bg-primary">
                                <div class="max-w700 m-auto p-tb50 p-lr20">
                                    <div class="text-white">
                                        <center>  <h2>{t('Notre politique qualité')}</h2> </center>
                                    </div>
                                    <div class="icon-bx-wraper m-b10 left" data-aos="fade-up">
                                        <div class="icon-md">
                                            <Link to={"/#"} class="icon-cell text-white">
                                                <i class="flaticon-planet-earth"></i>
                                            </Link>
                                        </div>
                                        <div class="icon-content">
                                            <h6 class="dlab-tilte">{t('Les autorités légales et règlementaires')} </h6>
                                            <p>{t('Fournir un produit dans le respect des exigences légales et règlementaires relative à notre activité')}</p>
                                        </div>
                                    </div>
                                    <div class="icon-bx-wraper m-b10 left" data-aos="fade-up">
                                        <div class="icon-md">
                                            <Link to={"/#"} class="icon-cell text-white">
                                                <i class="flaticon-user"></i>
                                            </Link>
                                        </div>
                                        <div class="icon-content">
                                            <h6 class="dlab-tilte">{t('Clients')} </h6>
                                            <p>{t('Instaurer des relations avec les clients qui ne reposent pas uniquement sur un dialogue économique..')}</p>
                                        </div>
                                    </div>
                                    <div class="icon-bx-wraper m-b10 left" data-aos="fade-up">
                                        <div class="icon-md">
                                            <Link to={"/#"} class="icon-cell text-white">
                                                <i class="flaticon-worker"></i>
                                            </Link>
                                        </div>
                                        <div class="icon-content">
                                            <h6 class="dlab-tilte">{t('Fournisseurs')}</h6>
                                            <p>{t('Travailler étroitement avec les fournisseurs et développer une attitude de partenariat')}</p>
                                        </div>
                                    </div>
                                    <div class="icon-bx-wraper m-b10 left" data-aos="fade-up">
                                        <div class="icon-md">
                                            <Link to={"/#"} class="icon-cell text-white">
                                                <i class="flaticon-helmet"></i>
                                            </Link>
                                        </div>
                                        <div class="icon-content">
                                            <h6 class="dlab-tilte">{t('Personnel')} </h6>
                                            <p>{t('Impliquer le personnel dans l’amélioration continue et la gestion des risques et des opportunités')} </p>
                                        </div>
                                    </div>
                                    <div class="icon-bx-wraper m-b10 left" data-aos="fade-up">
                                        <div class="icon-md">
                                            <Link to={"/#"} class="icon-cell text-white">
                                                <i class="flaticon-analytics"></i>
                                            </Link>
                                        </div>
                                        <div class="icon-content">
                                            <h6 class="dlab-tilte">{t('Actionnaire')} </h6>
                                            <p>{t('Assurer l’efficacité et l’efficience de SMQ ainsi que la croissance et la rentabilité de l’entreprise ')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section-full bg-img-fix content-inner-2 overlay-black-dark contact-action style2" style={{ backgroundImage: "url(" + bg2 + ")" }}>
                        <div class="container">
                            <div class="row relative">
                                <div class="col-md-12 col-lg-8 wow fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s">
                                    <div class="contact-no-area">
                                        <h2 class="title">{t('Nous Offrons Une Variété Demballage Pour Vos Produits')}</h2>
                                        <div class="contact-no">
                                            <div class="contact-left">
                                                <h3 class="no"><i class="sl-call-in"></i>+216 71 136 670</h3>
                                            </div>
                                            <div class="contact-right">
                                                <Link to="/contact" class="site-button appointment-btn btnhover13">{t('Contactez-Nous')}</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-4 contact-img-bx wow fadeInRight" data-wow-duration="2s" data-wow-delay="0.2s">
                                    <img src="" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer lang={lang} SetLang={SetLang} />
            <ScrollToTop className="scroltop style2 radius " />

        </>
    )
}
export default Présentation;